import { useCallback, useEffect, useState } from 'react';

export const useDebouncedSearch = (delay: number = 300) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [debouncedValue, setDebouncedValue] = useState<string>('');

  useEffect(() => {
    const abortController = new AbortController();

    const timer = setTimeout(() => {
      if (!abortController.signal.aborted) {
        setDebouncedValue(searchTerm);
      }
    }, delay);

    return () => {
      abortController.abort();
      clearTimeout(timer);
    };
  }, [searchTerm, delay]);

  const handleSearchChange = useCallback((text: string) => {
    setSearchTerm(text);
  }, []);

  return {
    searchTerm,
    debouncedValue,
    handleSearchChange,
  };
};
